import { render, staticRenderFns } from "./ReviewAvailability.vue?vue&type=template&id=59b681ba&scoped=true&"
import script from "./ReviewAvailability.vue?vue&type=script&lang=js&"
export * from "./ReviewAvailability.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAvailability.vue?vue&type=style&index=0&id=59b681ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b681ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VFlex,VIcon,VLayout,VSubheader})
